import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { Table, TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { PdfViewerPageComponent } from "../../../../shared/components/pdf-viewer-page/pdf-viewer-page.component";
import { PrintGetSalesOrderReportHeaderRequest } from "../../../../core/models/orders/PrintGetSalesOrderReportHeaderRequest";
import { SaleOrderLineAddressDto } from "../../../../core/models/orders/saleOrderLineAddressDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { FormsModule } from "@angular/forms";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ExchangeRatesDto } from "../../../../core/models/shared/exchangeRateDto";

import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { NumberOnlyWithTwoDecimalsDirective } from "../../../../core/directives/number-only-with-two-decimals.directive";
import { TooltipModule } from "primeng/tooltip";
@Component({
  selector: "jni-order-summary-line-items-report",
  templateUrl: "./order-summary-line-items-report.component.html",
  styleUrls: ["./order-summary-line-items-report.component.scss"],
  //providers: [NgbPopoverConfig],
  imports: [
    TableModule,
    CommonModule,
    PdfViewerPageComponent,
    ModalStackerComponent,
    FormsModule,
    CardModule,
    InputTextModule,
    ButtonModule,
    ToggleSwitchModule,
    NumberOnlyWithTwoDecimalsDirective,
    TooltipModule,
  ],
})
@UntilDestroy()
export class OrderSummaryLineItemsReportComponent {
  @Input() salesOrderId = "";
  @Input() salesOrderLine: SaleOrderLineAddressDto[] = [];
  @Input() OrderLineId = "";
  @Input() currencyConversion!: ExchangeRatesDto;
  @Input() foreignCurrency!: string;
  @Input() reportType = "";
  selectedSaleOrderLine: SaleOrderLineAddressDto[] = [];
  @Input() serviceFeeFromD365 = 0;
  @Input() showProFormalDialogHeading = "";

  toolTipOptions = {
    autoHide: false,
    escape: false,
    tooltipEvent: "hover" as const,
    tooltipPosition: "top" as const,
    tooltipStyleClass: "tooltipwidth",
  };

  showSmallLoader = false;
  //selectedLines: any;
  isoCurrencyCode = "";
  netReteAfterConversion = 0;
  netConvertToUsd = "";
  netTotalPrice = "";
  netTotalPriceConverted = "";

  sellReteAfterConversion = 0;
  sellConvertToUsd = "";
  sellTotalPrice = "";
  sellTotalPriceConverted = "";
  showLoader = true;
  grossProfit = 0;
  commission = 0;
  percentageSign = "%";

  @ViewChild("dt") table!: Table;
  @ViewChild("copyline", { static: false })
  descriptionCharacterCond = false;
  dialogEstimatedFreight = "";
  dialogEstimatedTax = "";
  dialogIncludeShippingHandling = false;
  dialogPercentage = "";

  pdfViewerPage = false;
  base64Pdf = "";
  fileNameToDownload = "";
  @Output() closeModalEvent = new EventEmitter();

  // @ViewChild('vendorSkuInput') vendorSkuInput: any;
  constructor(
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    //private config: NgbPopoverConfig,
    private _orderSummaryService: OrderSummaryService
  ) {
    // this.config.placement = 'end';
    // this.config.triggers = 'hover';
  }

  getNetGpPercentage(netTotal: number, sellTotal: number) {
    const serviceFee = this.serviceFeeFromD365 * sellTotal;
    const netGp = sellTotal - netTotal - serviceFee;
    const netGpPercentage = (netGp / sellTotal) * 100;

    if (Number.isFinite(netGpPercentage)) {
      return netGpPercentage;
    } else {
      return 0;
    }
  }

  getOddEvenNumber(lineNumber: number) {
    if (lineNumber % 2 === 0) {
      return true;
    } else {
      return false;
    }
  }

  descriptionCharacterCount(obj: string) {
    if (obj) {
      if (obj.length > 45) this.descriptionCharacterCond = true;
    }
  }
  printProFormalDialog() {
    if (this.selectedSaleOrderLine.length <= 0) {
      this._toastr.error("Error", `Please select at least one row`);
      return;
    }

    const selectedLinesRecIds = this.selectedSaleOrderLine.map(
      x => x.salesOrderLine?.id
    );

    if (this.reportType === "proFormaInvoice") {
      this.printProFormalInvoiceReport(selectedLinesRecIds);
    } else if (this.reportType === "depositInvoice") {
      this.printDepositInvoiceReport(selectedLinesRecIds);
    }
  }

  printProFormalInvoiceReport(selectedRecIds: (number | undefined)[]) {
    const objRequest = {
      salesId: this.salesOrderId,
      estimatedFreight: this.dialogEstimatedFreight || "0.00",
      estimatedTax: this.dialogEstimatedTax || "0.00",
      includeShippingAndHandling: this.dialogIncludeShippingHandling,
      salesOrderLinesIds: selectedRecIds,
      reportType: "ProFormaInvoiceReport",
    } as PrintGetSalesOrderReportHeaderRequest;

    this._loaderService.setLoaderState(true);
    this._orderSummaryService
      .printGetSalesOrderReportHeader(objRequest)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (
            res?.status.toLowerCase() === "success" &&
            res?.data?.base64String
          ) {
            // const blob = this.b64toBlob(
            //   res.data.base64String,
            //   'application/pdf'
            // );
            // const blobUrl = URL.createObjectURL(blob);
            // window.open(blobUrl);

            this.base64Pdf = res.data.base64String;
            this.fileNameToDownload = `ProFormaInvoice-${this.salesOrderId}`;
            this.pdfViewerPage = true;
          } else {
            this._toastr.error(
              "Error",
              res?.message || `Error while calling the dynamics api`
            );
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", `Error while calling the dynamics api's`);
        },
      });
  }

  printDepositInvoiceReport(selectedRecIds: (number | undefined)[]) {
    if (
      !this.dialogPercentage ||
      parseFloat(this.dialogPercentage) <= 1 ||
      parseFloat(this.dialogPercentage) > 100
    ) {
      this._toastr.error(
        "Error",
        `Percentage value must be greater than 1 and less than or equal to 100`
      );
      return;
    }
    const objRequest = {
      salesId: this.salesOrderId,
      estimatedFreight: this.dialogEstimatedFreight || "0.00",
      estimatedTax: this.dialogEstimatedTax || "0.00",
      includeShippingAndHandling: this.dialogIncludeShippingHandling,
      salesOrderLinesIds: selectedRecIds,
      percentage: this.dialogPercentage || "1.01",
      reportType: "DepositInoviceReport",
    } as PrintGetSalesOrderReportHeaderRequest;

    this._loaderService.setLoaderState(true);
    this._orderSummaryService
      .printGetSalesOrderReportHeader(objRequest)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (
            res?.status.toLowerCase() === "success" &&
            res?.data?.base64String
          ) {
            // const blob = this.b64toBlob(
            //   res.data?.base64String,
            //   'application/pdf'
            // );
            // const blobUrl = URL.createObjectURL(blob);
            // window.open(blobUrl);

            this.base64Pdf = res.data.base64String;
            this.fileNameToDownload = `DepositInvoice-${this.salesOrderId}`;
            this.pdfViewerPage = true;
          } else {
            this._toastr.error(
              "Error",
              res?.message || `Error while calling the dynamics api`
            );
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", `Error while calling the dynamics api's`);
        },
      });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  closeModalPdfViewerPage() {
    this.pdfViewerPage = false;
  }

  closeModal() {
    this.closeModalEvent.emit();
  }
}
